import { useContext } from 'react';
import { Formik } from 'formik';
import { CircleLoader } from 'components';
import ShipmentTypeForm from './components';
import { shipmentTypeContext, shipmentTypeSchema } from './ShipmentTypeDetailsContext';
import { Container } from '@mui/material';

let ShipmentTypeDetails = () => {

    let service = useContext(shipmentTypeContext);

    return (
        <Container maxWidth="md">
            <Formik
                enableReinitialize={true}
                initialValues={service.shipmentType}
                validationSchema={shipmentTypeSchema}
                onSubmit={(values, action) => {
                    service.saveShipmentType(values);
                    action.setSubmitting(false);;
                }}
            >
                <>
                    {service.isLoading && <CircleLoader />}
                    {service.isLoading === false && <ShipmentTypeForm />}
                </>
            </Formik>
        </Container>
    )
}

export default ShipmentTypeDetails;